export function isSwedishAppLanguage(language?: string): boolean {
  const normalized = typeof language === 'string' ? language.trim().toUpperCase() : '';
  return normalized === 'SE' || normalized === 'SV' || normalized.indexOf('SV-') === 0;
}

export function htmlLanguageForAppLanguage(language?: string): 'sv' | 'en' {
  return isSwedishAppLanguage(language) ? 'sv' : 'en';
}

export function dateLocaleForAppLanguage(language?: string): 'sv-SE' | 'en-GB' {
  return isSwedishAppLanguage(language) ? 'sv-SE' : 'en-GB';
}

export function applyDocumentLanguage(language?: string, root?: HTMLElement): string {
  const htmlLanguage = htmlLanguageForAppLanguage(language);
  const documentRoot = root || (
    typeof document !== 'undefined' ? document.documentElement : undefined
  );

  if (documentRoot) {
    documentRoot.lang = htmlLanguage;
  }

  return htmlLanguage;
}



// WEBPACK FOOTER //
// ./src/helpers/appLanguage.ts